const getAttrs = (config) => {
	const def = {
		deliminator: ':',
		...config && config.getAttrs || {}
	};

	return (attrs, element = null, deliminator = def.deliminator) => {
		if (element) {
			const prefix = element + deliminator;
			return Object
				.keys(attrs)
				.filter(key => key.indexOf(prefix) === 0)
				.reduce((output, key) => {
					output[key.replace(prefix, '')] = attrs[key];
					return output;
				}, {});
		} else {
			return Object
				.keys(attrs)
				.filter(key => key.indexOf(deliminator) < 0)
				.reduce((output, key) => {
					output[key] = attrs[key];
					return output;
				}, {});
		}
	};
};


export default {
	getAttrs
};